export const filterConfig = {
  cct: [
    {
      title: 'FINDINGS',
      isBoolean: true,
      options: [
        { key: 'adrenal_tumors', label: 'ADRENAL TUMORS', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'airiness', label: 'AIRINESS', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'aorta', label: 'AORTA', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'compression_fractures', label: 'COMPRESSION FRACTURES', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'coronary_calcium', label: 'CORONARY CALCIUM', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'emphysema', label: 'EMPHYSEMA', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'lung_nodules', label: 'LUNG NODULES', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'lymph_nodes_chest', label: 'LYMPH NODES CHEST', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'paracardial_fat', label: 'PARACARDIAL FAT', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'pleural_effusion', label: 'PLEURAL EFFUSION', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'pneumothorax', label: 'PNEUMOTHORAX', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'ribs_fractures', label: 'RIBS FRACTURES', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'trunk_dilatation', label: 'TRUNK DILATATION', value: true, className: 'flex-1 whitespace-nowrap' },
      ],
    },
    {
      title: 'PRIORITY',
      options: [
        { key: 'priority', label: 'LOW', value: 'BAIXA', className: 'flex-1' },
        { key: 'priority', label: 'MODERATE_', value: 'MODERADA', className: 'flex-1' },
        { key: 'priority', label: 'HIGH', value: 'ALTA', className: 'flex-1' },
      ],
    },
  ],
  cxr: [
    {
      title: 'FINDINGS',
      isBoolean: true,
      justify: 'around',
      options: [
        { key: 'arthrodesis', label: 'ARTHRODESIS', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'cardiomegaly', label: 'CARDIOMEGALY', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'cvc', label: 'CVC', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'drain', label: 'DRAIN', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'electrodes', label: 'ELECTRODES', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'pacemaker', label: 'PACEMAKER', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'sng', label: 'SNG', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'sternum_wires', label: 'STERNUM WIRES', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'tot', label: 'TOT', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'emphysema', label: 'SUB EMPHYSEMA', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'nodule', label: 'NODULE', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'mass', label: 'MASS', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'opacity', label: 'OPACITY', value: true, className: 'flex-1 whitespace-nowrap' },
      ],
    },
    {
      title: 'EFFUSION',
      options: [
        { key: 'effusion', label: 'ABSENT', value: 'AUSENTE', className: 'flex-1' },
        { key: 'effusion', label: 'MILD', value: 'PEQUENO', className: 'flex-1' },
        { key: 'effusion', label: 'MODERATE', value: 'MODERADO', className: 'flex-1' },
        { key: 'effusion', label: 'SEVERE', value: 'GRAVE', className: 'flex-1' },
      ],
    },
    {
      title: 'PTX',
      options: [
        { key: 'ptx', label: 'ABSENT', value: 'AUSENTE', className: 'flex-1' },
        { key: 'ptx', label: 'MILD', value: 'PEQUENO', className: 'flex-1' },
        { key: 'ptx', label: 'MODERATE', value: 'MEDIO', className: 'flex-1' },
        { key: 'ptx', label: 'SEVERE', value: 'GRANDE', className: 'flex-1' },
      ],
    },
    {
      title: 'FRACTURE',
      options: [
        { key: 'fracture', label: 'ABSENT', value: 'AUSENTE', className: 'flex-1' },
        { key: 'fracture', label: 'COSTAL ARCH', value: 'ARCO COSTAL', className: 'flex-1' },
        { key: 'fracture', label: 'CLAVICLE', value: 'CLAVICULA', className: 'flex-1' },
        { key: 'fracture', label: 'BOTH', value: 'AMBOS', className: 'flex-1' },
      ],
    },
    {
      title: 'PRIORITY',
      options: [
        { key: 'priority', label: 'LOW', value: 'BAIXA', className: 'flex-1' },
        { key: 'priority', label: 'MODERATE_', value: 'MODERADA', className: 'flex-1' },
        { key: 'priority', label: 'HIGH', value: 'ALTA', className: 'flex-1' },
      ],
    },
  ],
  do: [
    {
      title: 'BMD',
      options: [
        { key: 'bmd', label: 'NORMAL', value: 'NORMAL', className: 'flex-1' },
        { key: 'bmd', label: 'OSTEOPENIA', value: 'OSTEOPENIA', className: 'flex-1' },
        { key: 'bmd', label: 'OSTEOPOROSE', value: 'OSTEOPOROSE', className: 'flex-1' },
      ],
    },
  ],
  mammo: [
    {
      title: 'FINDINGS',
      isBoolean: true,
      options: [
        { key: 'axillary_lymph', label: 'AXILLARY LYMPH', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'lymph_node', label: 'LYMPH NODE', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'silicone_implant', label: 'SILICONE IMPLANT', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'symmetry', label: 'SYMMETRY', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'fibroadenoma', label: 'FIBROADENOMA', value: true, className: 'flex-1 whitespace-nowrap' },
      ],
    },
    {
      title: 'BIRADS',
      options: [
        { key: 'birads', label: '0', value: '0', className: 'flex-1' },
        { key: 'birads', label: '1', value: '1', className: 'flex-1' },
        { key: 'birads', label: '2', value: '2', className: 'flex-1' },
        { key: 'birads', label: '3', value: '3', className: 'flex-1' },
        { key: 'birads', label: '4', value: '4', className: 'flex-1' },
        { key: 'birads', label: '5', value: '5', className: 'flex-1' },
      ],
    },
    {
      title: 'CALCIFICATION',
      options: [
        { key: 'calcification', label: 'ABSENT', value: 'AUSENTE', className: 'flex-1' },
        { key: 'calcification', label: 'BENIGN', value: 'BENIGNA', className: 'flex-1' },
        { key: 'calcification', label: 'SUSPECTED_', value: 'SUSPEITA', className: 'flex-1' },
      ],
    },
    {
      title: 'DENSITY',
      options: [
        { key: 'density', label: 'A', value: 'A', className: 'flex-1' },
        { key: 'density', label: 'B', value: 'B', className: 'flex-1' },
        { key: 'density', label: 'C', value: 'C', className: 'flex-1' },
        { key: 'density', label: 'D', value: 'D', className: 'flex-1' },
      ],
    },
    {
      title: 'NODULE',
      options: [
        { key: 'nodule', label: 'ABSENT', value: 'AUSENTE', className: 'flex-1' },
        { key: 'nodule', label: 'PRESENT', value: 'PRESENTE', className: 'flex-1' },
        { key: 'nodule', label: 'SUSPECTED', value: 'SUSPEITO', className: 'flex-1' },
      ],
    },
    {
      title: 'PRIORITY',
      options: [
        { key: 'priority', label: 'LOW', value: 'BAIXA', className: 'flex-1' },
        { key: 'priority', label: 'MODERATE_', value: 'MODERADA', className: 'flex-1' },
        { key: 'priority', label: 'HIGH', value: 'ALTA', className: 'flex-1' },
      ],
    },
    {
      title: 'QUALITY',
      options: [
        { key: 'quality', label: 'PERFECT', value: 'PERFEITA', className: 'flex-1' },
        { key: 'quality', label: 'GOOD', value: 'BOA', className: 'flex-1' },
        { key: 'quality', label: 'MODERATE_', value: 'MODERADA', className: 'flex-1' },
        { key: 'quality', label: 'INADEQUATE', value: 'INADEQUADA', className: 'flex-1' },
      ],
    },
  ],
  mskxr: [
    {
      title: 'FINDINGS',
      isBoolean: true,
      options: [
        { key: 'fracture', label: 'FRACTURE', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'cast', label: 'CAST', value: true, className: 'flex-1 whitespace-nowrap' },
        { key: 'osteosynthesis', label: 'OSTEOSYNTHESIS', value: true, className: 'flex-1 whitespace-nowrap' },
      ],
    },
    {
      title: 'PRIORITY',
      options: [
        { key: 'priority', label: 'LOW', value: 'BAIXA', className: 'flex-1' },
        { key: 'priority', label: 'MODERATE_', value: 'MODERADA', className: 'flex-1' },
        { key: 'priority', label: 'HIGH', value: 'ALTA', className: 'flex-1' },
      ],
    },
  ],
  // hct: [
  //   {
  //     title: 'PRIORITY',
  //     options: [
  //       { key: 'priority', label: 'LOW', value: 'BAIXA', className: 'flex-1' },
  //       { key: 'priority', label: 'MODERATE_', value: 'MODERADA', className: 'flex-1' },
  //       { key: 'priority', label: 'HIGH', value: 'ALTA', className: 'flex-1' },
  //     ],
  //   },
  // ],
};
